import { addSeconds, format, intervalToDuration, parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export default function useDateFormatter() {
  const formatDate = (time: Date, timeFormat: string) => {
    return format(new Date(time), timeFormat);
  };

  const datesEqual = (date1: Date, date2: Date) => {
    date1 = new Date(date1);
    date2 = new Date(date2);
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  };

  const calcDuration = (start: string, end: string) => {
    const parseDate = (dateStr: string) => parseISO(dateStr.replace(' ', 'T').split('.')[0]);

    const startDate = parseDate(start);
    const endDate = parseDate(end);

    return intervalToDuration({ start: startDate, end: endDate });
  };

  const formatSeconds = (seconds) => {
    let date = addSeconds(new Date(0), seconds);
    const zonedTime = toZonedTime(date, 'UTC');
    return format(zonedTime, 'HH:mm:ss');
  };

  return { formatDate, datesEqual, calcDuration, formatSeconds };
}
